import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';

const Styles = styled.div``;

const SelectTipoTecnologia = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    disabled,
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    const options = [
        {
            value: 'Común',
            label: 'Común',
        },
        {
            value: 'Infrarrojo',
            label: 'Infrarrojo',
        },
        {
            value: 'Detección de Patentes',
            label: 'Detección de Patentes',
        },
        {
            value: 'Detección de Rostros',
            label: 'Detección de Rostros',
        }
    ];
    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value]);

    return (
        <Styles>
            <Select
                {...defaultProps}
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
                isDisabled={disabled}
            />
        </Styles>
    );
};

SelectTipoTecnologia.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectTipoTecnologia;